import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { RawCheckbox, type RawCheckboxProps } from './RawCheckbox'

export type CheckboxProps = RawCheckboxProps & InputProps

export const Checkbox = ({ wrapperProps, ...fieldProps }: CheckboxProps) => (
  <InputWrapper {...wrapperProps} labelType="headless">
    <RawCheckbox {...fieldProps} />
  </InputWrapper>
)
